/**
 * Detect the user's device type
 * @returns {string} 'ios', 'android', or 'other'
 */
export function detectDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios'
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return 'android'
  }

  // Default to iOS for desktop users (can be changed)
  return 'other'
}

/**
 * Redirect user to the appropriate app store
 * @param {string} device - The device type ('ios', 'android', or 'other')
 */
export function redirectToStore(device) {
  // Replace these with your actual app store URLs
  const appStoreLinks = {
    ios: 'https://apps.apple.com/us/app/breakout-meeting/id6753223729', // Replace with actual App Store URL
    android: 'https://play.google.com/store/apps/details?id=com.breakout.app', // Replace with actual Play Store URL
    other: 'https://apps.apple.com/us/app/breakout-meeting/id6753223729' // Default fallback
  }

  const url = appStoreLinks[device] || appStoreLinks.other
  window.location.href = url
}

/**
 * Check if the app is installed and attempt to open it
 * @param {string} deepLinkUrl - The deep link URL to open
 * @param {function} fallback - Fallback function to call if app is not installed
 */
export function tryOpenApp(deepLinkUrl, fallback) {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = deepLinkUrl
  
  document.body.appendChild(iframe)
  
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 2000)

  // If the app doesn't open, call the fallback
  setTimeout(() => {
    if (document.hidden || document.webkitHidden) {
      // App likely opened, do nothing
      return
    }
    // App didn't open, execute fallback
    if (fallback) {
      fallback()
    }
  }, 2500)
}
